var cdnjs = {
    "lightGallery": "https://cdnjs.cloudflare.com/ajax/libs/lightgallery/1.2.19/js/lightgallery-all.min.js",
    "lightGallery_css": "https://cdnjs.cloudflare.com/ajax/libs/lightgallery/1.2.19/css/lightgallery.min.css",
    "select2": "//cdnjs.cloudflare.com/ajax/libs/select2/4.0.3/js/select2.min.js",
    "select2_css": "//cdnjs.cloudflare.com/ajax/libs/select2/4.0.3/css/select2.min.css",
    "cookieconsent": "https://packages.newlogic.cz/newlogic-cookieconsent/1.0.0/js/newlogic-cookieconsent-lui.min.js?id=weblepsiuklid"
}
